module.exports = __webpack_public_path__ + "img/clonbrowser_en.eec01dfa.png";